import React from 'react';
import { action, observable } from "mobx";

import shirt from '../../svgs/Shirt';

export default class ShirtTransformer {
    transform(value) {
            
        return (
            <div>
               {shirt('blue')} <label htmlFor="">Some desc</label>
            </div>
        );
    }
}